import { render } from "./EntityCard.vue?vue&type=template&id=04763cbe&scoped=true"
const script = {}

import "./EntityCard.vue?vue&type=style&index=0&id=04763cbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04763cbe"]])

export default __exports__